export default class MobileOverlayMenu {
  constructor() {
    this.toggle = document.querySelector('.menu-toggle');
    this.overlay = document.querySelector('.menu-overlay');
    this.links = this.overlay?.querySelectorAll('a');

    if (!this.toggle || !this.overlay) return;

    this.bindEvents();
  }

  bindEvents() {
    this.toggle.addEventListener('click', () => this.toggleMenu());

    this.links.forEach(link => {
      link.addEventListener('click', () => this.closeMenu());
    });
  }

  toggleMenu() {
    this.toggle.classList.toggle('is-active');
    this.overlay.classList.toggle('is-open');

    document.body.style.overflow =
      this.overlay.classList.contains('is-open') ? 'hidden' : '';
  }

  closeMenu() {
    this.toggle.classList.remove('is-active');
    this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}